<template>
  <div class="supplierMaintenance401">
    <div class="header">
      <img
        src="@/assets/img/login/logo.png"
        alt="智生活 Logo"
      >
    </div>
    <div class="body">
      <div class="img">
        <img
          src="@/assets/img/error/403.svg"
          alt=""
        >
      </div>
      <div class="title">
        QRCode 過期失效
      </div>
      <div class="content">
        此連結因超過時間限制已失效，請聯繫社區管理人員，再次產出 QRCode
      </div>
    </div>
  </div>
</template>

<script>

export default {
}
</script>

<style lang="scss" scoped>
.supplierMaintenance401 {
  width: 100%;
  height: 100vh;
  max-height: -webkit-fill-available;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  .header {
    flex: 0 0 64px;
    background-color: $mainColor;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      height: 39px;
    }
  }
  .body {
    flex-grow: 1;
    padding: 36px 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    overflow-y: scroll;
    justify-content: center;
    align-items: center;
    .img{
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        width: 90%;
      }
    }
    .title{
      padding-top: 40px;
      font-size: 23px;
      font-weight: 600;
    }
    .content{
      padding-top: 32px;
      font-size: 19px;
      text-align: center;
    }
  }
}
</style>
